import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as QRCode from 'qrcode';

@Component({
    selector: 'app-qr-code-popup',
    templateUrl: './qr-code-popup.component.html',
    styleUrls: ['./qr-code-popup.component.scss']
})
export class QrCodePopupComponent implements OnInit {
    @Input() url: string = '';
    @Output() closePopup = new EventEmitter<void>();

    qrCodeImage: string = '';

    constructor() { }

    ngOnInit(): void {
        this.generateQRCode();
    }

    private generateQRCode(): void {
        if (!this.url) {
            console.error('URL is required to generate QR code');
            return;
        }

        QRCode.toDataURL(this.url, {
            width: 256,
            margin: 2,
            color: {
                dark: '#000000',
                light: '#FFFFFF'
            }
        })
        .then((url: string) => {
            this.qrCodeImage = url;
        })
        .catch((err: any) => {
            console.error('Error generating QR code:', err);
        });
    }

    close(): void {
        this.closePopup.emit();
    }

    onBackdropClick(event: MouseEvent) {
        if (event.target === event.currentTarget) {
            this.close();
        }
    }

    onPopupClick(event: MouseEvent) {
        // Prevents the click on the popup from closing it
        event.stopPropagation();
    }
}